import { useTranslation } from "react-i18next";
import { Badge } from "@/components/ui/badge";

interface NewBadgeProps {
  className?: string;
}

export function NewBadge({ className }: NewBadgeProps) {
  const { t } = useTranslation("sharing");

  return (
    <Badge
      variant="success"
      className={`w-auto h-5 px-2 text-[0.65rem] uppercase tracking-wide ${
        className ?? ""
      }`}
      data-testid="new-badge"
    >
      {t("card.newBadge")}
    </Badge>
  );
}
